module.exports = __webpack_public_path__ + "static/media/skull.de10342d.svg";